<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.ITEM_TABLE_TOOLS.TITLE' | translate }}</h4>

  <div class="preset-buttons">
    @if (isPresetActive('list')) {
      <button mat-flat-button type="button" class="preset-button" (click)="applyPreset('list')">
        <span class="button-inner">
          <gb-icon icon="list" height="18px"></gb-icon>
          <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.PRESETS.LIST' | translate }}</span>
        </span>
      </button>
    } @else {
      <button mat-stroked-button type="button" class="preset-button" (click)="applyPreset('list')">
        <span class="button-inner">
          <gb-icon icon="list" height="18px"></gb-icon>
          <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.PRESETS.LIST' | translate }}</span>
        </span>
      </button>
    }

    @if (isPresetActive('grid')) {
      <button mat-flat-button type="button" class="preset-button" (click)="applyPreset('grid')">
        <span class="button-inner">
          <gb-icon icon="grid" height="18px"></gb-icon>
          <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.PRESETS.GRID' | translate }}</span>
        </span>
      </button>
    } @else {
      <button mat-stroked-button type="button" class="preset-button" (click)="applyPreset('grid')">
        <span class="button-inner">
          <gb-icon icon="grid" height="18px"></gb-icon>
          <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.PRESETS.GRID' | translate }}</span>
        </span>
      </button>
    }
  </div>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.ITEM_TABLE_TOOLS.TRANSITION' | translate }}</mat-label>
    <mat-select [formControl]="transitionControl">
      @for (option of transitionOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-slide-toggle [formControl]="imageContainedControl">
    {{ 'PRESENTER.ITEM_TABLE_TOOLS.IMAGE_CONTAINED' | translate }}
  </mat-slide-toggle>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tablePrimaryColorControl"
    labelTranslateKey="PRESENTER.ITEM_TABLE_TOOLS.TABLE_PRIMARY_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableBackgroundColorControl"
    labelTranslateKey="PRESENTER.ITEM_TABLE_TOOLS.TABLE_BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  @if (!isTemplateMode) {
    <button mat-stroked-button type="button" class="preset-button" (click)="openFilterItemsDialog()">
      <span class="button-inner">
        <gb-icon icon="filter" height="18px"></gb-icon>
        <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.BUTTON' | translate }}</span>
      </span>
    </button>

    @if (excludedItemsCount > 0) {
      <button type="button" class="excluded-items-link" (click)="openExcludedItemsDialog()">
        {{
          (excludedItemsCount === 1
            ? 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT_SINGULAR'
            : 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT'
          ) | translate: { count: excludedItemsCount }
        }}
      </button>
    }
  }

  <div class="form-field-row">
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.ITEM_TABLE_TOOLS.COLUMNS' | translate }}</mat-label>
      <input matInput type="number" [formControl]="columnsControl" min="1" max="10" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'PRESENTER.ITEM_TABLE_TOOLS.ROWS' | translate }}</mat-label>
      <input matInput type="number" [formControl]="rowsControl" min="1" max="50" />
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.ITEM_TABLE_TOOLS.SLIDE_INTERVAL' | translate }}</mat-label>
    <input matInput type="number" [formControl]="slideIntervalControl" min="1" max="3600" />
    <span matTextSuffix>{{ 'S' | translate }}</span>
  </mat-form-field>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>
</div>
